import React from "react";
import "./EarnRewards.scss";
import "react-lazy-load-image-component/src/effects/blur.css";
import EstatementVariant from "./components/EstatementVariant/EstatementVariant";
import DiversityVariant from "./components/DiversityVariant/DiversityVariant"
import DefaultVariant from "./components/DefaultVariant";
import AlertsVariant from "./components/AlertsVariant/AlertsVariant";

type FieldItem = {
  itemId: string;
  itemImageUrl: string;
  itemImageWidth: string;
  itemImageHeight: string;
  itemImageAlt: string;
  itemRewardsHeader: string;
  itemRewardsSubHeader: string;
  itemRewardsDescription: string;
};

type EarnRewardsPropsTypes = {
  earnRewardsPageName: string;
  earnRewardsId: string;
  earnRewardsBgColor: string;
  earnRewardsBgDesktopHeight: string;
  earnRewardsBgTabletHeight: string;
  earnRewardsBgMobileHeight: string;
  earnRewardsHeaderText: string;
  earnRewardsHeaderTextColor: string;
  earnRewardsDescription: string;
  earnRewardsDescriptionTextColor: string;
  earnRewardsDetailsItems: FieldItem[];
  earnRewardsLinkText: string;
  earnRewardsLinkUrl: string;
  earnRewardsLinkAriaLabel: string;
  earnRewardsButtonText: string;
  earnRewardsButtonUrl: string;
  earnRewardsButtonAriaLabel: string;
  isInEditor: boolean;
  cqPath: string;
};

export default function EarnRewardsReact(props: EarnRewardsPropsTypes) {

  const isDIB =props.earnRewardsPageName === "dib";
  const isEstatement = props.earnRewardsPageName === "estatement"
  const isAlertsPage = props.earnRewardsPageName === "alerts";

  if (isEstatement) {
    return <EstatementVariant {...props} />;
  }
  if (isAlertsPage) {
    return <AlertsVariant {...props} />;
  }
  if(isDIB){
    return<DiversityVariant {...props}/>
  }

  // credit protector, card, digital, deposit account
  return <DefaultVariant {...props} />;
}
